import { hashPhoneNumber as hashPhoneNumberImpl } from '../utils/phoneHashUtils';

/**
 * Hashes an identifier for Gainsight entities when it looks like a phone number.
 * Returns undefined for null or undefined inputs.
 * hashPhoneNumberImpl is a JS function that requires a non-null string.
 */
export function hashTrackingId(
  id: string | null | undefined,
): string | undefined {
  if (id == null) {
    return undefined;
  }

  return hashPhoneNumberImpl(id);
}
